import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";

function RatesEditModal({
    isOpen,
    onClose,
    filteredLanguagesLoadOptions,
    filteredCertificationsLoadOptions,
    onUpdate,
    editItem,
    loader,
}) {
    // Local state for modal fields
    // certification is now an object { id, label, value, rate }
    const [modalLang, setModalLang] = useState({ languageId: "", languageLabel: "", certification: null, rate: "", inpersonRate: "" });
    const [modalLanguageState, setModalLanguageState] = useState([]);

    // Prefill modal fields when opened for edit
    useEffect(() => {
        if (isOpen && editItem) {
            setModalLang({
                languageId: editItem.languageId || "",
                languageLabel: editItem.languageLabel || "",
                certification: editItem.certification || null,
                rate: editItem.rate,
                inpersonRate: editItem.inpersonRate ?? ""
            });
            setModalLanguageState(editItem.languageId ? [{ value: editItem.languageId, label: editItem.languageLabel }] : []);
        } else if (!isOpen) {
            setModalLang({ languageId: "", languageLabel: "", certification: null, rate: "" });
            setModalLanguageState([]);
        }
    }, [isOpen, editItem]);

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
                <div className="modal-header" style={{ padding: '30px', border: 'none' }}>
                    <h5 className="modal-title_u">Edit Rates</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                    ></button>
                </div>
                <div className="modal-body" style={{ padding: '30px', paddingBottom: '0' }}>
                    <div className="mb-3">
                        <div class="row-primary m-0 mb-4">
                            <h2>Languages Spoken</h2>
                            <AsyncPaginate
                                menuPlacement="auto"
                                styles={{ ...selectCustomStyles }}
                                value={modalLanguageState}
                                loadOptions={filteredLanguagesLoadOptions}
                                filterOption={null}
                                isClearable
                                escapeClearsValue
                                onChange={(selected) => {
                                    const sel = Array.isArray(selected) ? selected[0] : selected;
                                    setModalLanguageState(sel ? [sel] : []);
                                    setModalLang(prev => ({ ...prev, languageId: sel?.value || "", languageLabel: sel?.label || "" }));
                                }}
                                additional={{ page: 1 }}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <div class="row-primary m-0 mb-4">
                            <h2>Certification Type</h2>
                            <AsyncPaginate
                                menuPlacement="auto"
                                styles={{ ...selectCustomStyles }}
                                value={modalLang.certification ? { label: modalLang.certification.label, value: modalLang.certification.value } : null}
                                loadOptions={filteredCertificationsLoadOptions}
                                isClearable
                                onChange={(selected) => {
                                    setModalLang(prev => ({
                                        ...prev,
                                        certification: selected ? { id: selected.id, label: selected.label, value: selected.value, rate: selected.rate } : null,
                                        rate: selected?.rate || prev.rate
                                    }));
                                }}
                                additional={{ page: 1 }}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <div class="row-primary m-0">
                            <h2>VRI Rate</h2>
                            <input className="input-in type_inp" type="number" placeholder="VRI rate" value={modalLang.rate} onChange={(e) => setModalLang(prev => ({ ...prev, rate: e.target.value }))} />
                        </div>
                    </div>
                    <div className="mb-3">
                        <div class="row-primary m-0">
                            <h2>In Person Rate</h2>
                            <div style={{ width: '100%' }}>
                                <input className="input-in type_inp" type="number" placeholder="In person rate" value={modalLang.inpersonRate} onChange={(e) => setModalLang(prev => ({ ...prev, inpersonRate: e.target.value }))} />
                                <div style={{ fontSize: 12, color: '#809FB8', marginTop: 4 }}>
                                    Used when the job's location is not a Zoom location (the VRI rate applies to Zoom jobs). Defaults to $75.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal-footer' style={{ padding: '30px', border: 'none' }}>
                    <button className='Cancle_button' onClick={onClose}>Cancel</button>
                    <button className='main_button' onClick={() => onUpdate(modalLang)}>Update</button>
                </div>
            </Modal>
        </>
    );
}

export default RatesEditModal;